module.exports = __webpack_public_path__ + "static/media/Mondadori-logo.70e4e707.svg";